import { ErrorOutlineRounded } from '@mui/icons-material'
import { InformationCard } from 'feature/informationCard'
import { MainLayout } from 'layouts'
import { FC } from 'react'

export const ReviewErrorPage: FC = () => {
  return (
    <MainLayout>
      <div className='container'>
        <InformationCard
          title='Произошла ошибка'
          subtitle='Не удалось отправить отзыв, пожалуйста, попробуйте позже'
          Icon={<ErrorOutlineRounded fontSize='large' color='primary' />}
          link='/appeals'
          linkText='Мои обращения'
        />
      </div>
    </MainLayout>
  )
}
